import { render, staticRenderFns } from "./ListListas.vue?vue&type=template&id=06786aec"
import script from "./ListListas.vue?vue&type=script&lang=js"
export * from "./ListListas.vue?vue&type=script&lang=js"
import style0 from "./ListListas.vue?vue&type=style&index=0&id=06786aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports